<div *ngIf="loading" class="loader-overlay">
  <div class="loader"></div>
</div>
<div id="app" class="w-100">
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer-section></app-footer-section>
</div>